import React, { useState } from "react";
import { Link, NavLink as RRNavLink } from "react-router-dom";
import {
  Nav,
  Navbar,
  NavLink,
  NavbarBrand,
  NavbarToggler,
  Collapse,
} from "reactstrap";

const Navigation = ({ loggedIn, logout, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar dark id="navbar" expand="md">
      <NavbarBrand tag={Link} to="/home">
        Surf Journal
      </NavbarBrand>
      {loggedIn && (
        <>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar className="text-center">
            <Nav navbar className="mr-auto">
              <NavLink
                tag={RRNavLink}
                onClick={() => setIsOpen(false)}
                to="/home"
              >
                Home
              </NavLink>
              <NavLink
                tag={RRNavLink}
                onClick={() => setIsOpen(false)}
                to="/spots"
              >
                Spots
              </NavLink>
            </Nav>
            <Nav navbar className="ml-auto ">
              <NavLink
                tag={RRNavLink}
                onClick={() => setIsOpen(false)}
                to="/profile"
              >
                Profile
              </NavLink>
              {loggedIn && (
                <NavLink
                  tag={RRNavLink}
                  to="/logout"
                  onClick={() => {
                    setIsOpen(false);
                    logout();
                  }}
                  // onMouseUp={logout}
                >
                  Log Out
                </NavLink>
              )}
            </Nav>
          </Collapse>
        </>
      )}
    </Navbar>
  );
};

export default Navigation;
